import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ContactForm from './ContactForm';

const Footer: React.FC = () => {
  const [showContactForm, setShowContactForm] = useState(false);

  return (
    <footer className="bg-[#0A0E27] border-t border-white/10 pb-20 md:pb-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 md:py-6">
        {/* link columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
          <div>
            <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wide mb-3 md:mb-2">
              Legal
            </h3>
            <ul className="space-y-3 md:space-y-2">
              <li>
                <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors block py-1 text-base md:text-sm">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-300 hover:text-white transition-colors block py-1 text-base md:text-sm">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-gray-300 hover:text-white transition-colors block py-1 text-base md:text-sm">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wide mb-3 md:mb-2">
              Contact
            </h3>
            <ul className="space-y-3 md:space-y-2">
              <li>
                <button
                  onClick={() => setShowContactForm(true)}
                  className="text-gray-300 hover:text-white transition-colors block py-1 text-base md:text-sm text-left"
                >
                  Contact Support
                </button>
              </li>
              <li>
                <Link to="/safety" className="text-gray-300 hover:text-white transition-colors block py-1 text-base md:text-sm">
                  Safety Center
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wide mb-3 md:mb-2">
              Social
            </h3>
            <ul className="space-y-3 md:space-y-2">
              <li>
                <a
                  href="https://x.com/vybetribeapp"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors block py-1 text-base md:text-sm"
                >
                  X
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/vybetribe.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors block py-1 text-base md:text-sm"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/profile.php?id=61581449384413"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors block py-1 text-base md:text-sm"
                >
                  Facebook
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* bottom row */}
        <div className="pt-6 mt-8 md:pt-4 md:mt-4 border-t border-white/10 text-center">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} Vybe Tribe. All rights reserved.
          </p>
        </div>
      </div>

      <ContactForm isOpen={showContactForm} onClose={() => setShowContactForm(false)} />
    </footer>
  );
};

export default Footer;
